<form [formGroup]="datiGeneraliForm" (ngSubmit)="save()" *ngIf="request">
  <app-dati-generali-fascicolo-common [request]="request" [fascicolo]="fascicolo" [inserimento]="inserimento" [datiGeneraliForm]="datiGeneraliForm" (changedFondoRischiState)="changedFondoRischiState()"></app-dati-generali-fascicolo-common>                                                                        
  <app-protocol-fascicolo-form [fascicolo]="fascicolo" (protocolDataChange)="onDataProtocol($event)" [dataView]="protocollo" /> 

  <div class="row">
    <div class="col-sm-6">
      <p>
        <label for="oggetto-oppos-lbl">Oggetto</label>
        <input id="oggetto-oppos-lbl" class="form-control" type="text" disabled="" [value]="fascicolo && fascicolo.oggetto ? fascicolo.oggetto : null">
      </p>
    </div>

  </div>

  <div class="row">
    <!--<div singleCheckBoxModInput class="col-sm-2"
         [labelInput]="'Opposizione'" formControlName="opposizione"
         [objectReference]="request.fascicolo.opposizione"
         [(ngModel)]="request.fascicolo.opposizione"
         (onReturn)="request.fascicolo.opposizione = $event;"
         [mandatory]="true"></div>-->
    <div checkBoxRadio class="col-sm-2"
         formControlName="opposizione"
         idInput="opposizione"
         [labelInput]="'Atto della società'"
         [objectReference]="request.fascicolo.opposizione"
         (onReturn)="request.fascicolo.opposizione = $event;"
         [mandatory]="true"></div>

    <div class="col-sm-3">
      <p>
        <label for="tipo-provv-serv-lbl">Tipo provvedimento</label>
        <input id="tipo-provv-serv-lbl" class="form-control" type="text" disabled="" [value]="null">
      </p>
    </div>

    <div comboModInput class="col-sm-3"
         [labelInput]="'Organo ispettivo'" formControlName="organoIspettivo"
         [optionsCombo] ="organiIspettiviOptions"
         [objectReference]="request.fascicolo.organoIspettivo"
         [(ngModel)]="request.fascicolo.organoIspettivo"
         (onReturn)="request.fascicolo.organoIspettivo = $event;"
         [mandatory]="true"
    ></div>

    <div comboModInput class="col-sm-4"
         [labelInput]="'Provincia'" formControlName="provincia"
         [optionsCombo] ="provinceOptions"
         [objectReference]="request.fascicolo.provincia"
         [(ngModel)]="request.fascicolo.provincia"
         (onReturn)="request.fascicolo.provincia = $event;"
         [mandatory]="true"
    ></div>
  </div>

  <!-- <div class="row">

    <div checkBoxRadio class="col-sm-4"
         [labelInput]="'Recupero crediti'" idInput="recupero_crediti"
         formControlName="recuperoCrediti" [objectReference]="request.fascicolo.recuperoCrediti"
         (onReturn)="request.fascicolo.recuperoCrediti = $event"></div>

  </div> -->

  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12"
         [labelInput]="'Note'" formControlName="note"
         [(ngModel)]="request.fascicolo.note"></div>
  </div>

  <div>
    <h3 class="title1level">Campi personalizzati</h3>
        <app-fascicolo-metadata-form *ngIf="!fascicolo.id && fascicolo.tipoFascicolo.id"
          [tipoFascicolo]="fascicolo.tipoFascicolo.id"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
        <app-fascicolo-metadata-form *ngIf="fascicolo.id && fascicolo.tipoFascicolo.id"
          [fascicolo]="request.fascicolo"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
  </div>

  <div class="row">
    <p class="mandatory col-sm-12">
      <em>* Campi obbligatori</em>
    </p>
  </div>

  <div [ngClass]="minervaWizard ? 'wizard-buttons' : ''" class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block"
              (click)="resetForm.emit()">Reset</button>
    </p>
    <p submitButton	class="col-sm-3 col-xs-6 col-sm-offset-6"
       [labelButton]="minervaWizard ? 'Prosegui' : 'Salva'" [disabled]="!datiGeneraliForm.valid || !metadataFormValid"></p>
  </div>
</form>
